module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog1-5e4e2f02d3256c186d464902d2823636.jpg";